var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 2.25C17.7488 2.51017 21.489 6.25009 21.749 10.96V11.5C21.749 12.9299 21.4185 14.3597 20.7686 15.6396C19.1986 18.7895 16.0289 20.7499 12.499 20.75H12.4785C11.1586 20.75 9.83839 20.4601 8.64844 19.9102L3.23828 21.71C3.15851 21.7398 3.0788 21.75 2.99902 21.75C2.79911 21.75 2.60873 21.6702 2.46875 21.5303C2.26875 21.3303 2.19906 21.0298 2.28906 20.7598L4.08887 15.3496C3.52894 14.1497 3.23902 12.8199 3.24902 11.5C3.24902 7.98015 5.20863 4.81054 8.3584 3.23047C9.6384 2.59047 11.049 2.25 12.499 2.25H12.999ZM12.4785 3.75C11.2886 3.75002 10.099 4.0304 9.03906 4.57031C6.38906 5.89031 4.74902 8.55 4.74902 11.5C4.74902 12.6999 5.02841 13.89 5.56836 14.96C5.65836 15.14 5.6784 15.35 5.6084 15.54L4.17871 19.8203L8.45898 18.3896C8.64888 18.3298 8.85919 18.3397 9.03906 18.4297C10.099 18.9696 11.2886 19.25 12.4785 19.25H12.499C15.4489 19.2499 18.1088 17.6099 19.4287 14.96C19.9687 13.89 20.259 12.69 20.249 11.5V11C20.029 7.10011 16.8988 3.97015 12.959 3.75H12.4785Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.f25cb02070aa8161121e4579e2efcdbf.svg";
export { ForwardRef as ReactComponent };